import { detectionChineseType } from 'json/lab-order'
export let filterFactor = [ {
  label: '类型',
  type: 'select',
  clearable: true,
  value: 'type', // 需返回数据的字段名
  options: getTypes()
}]
export let tableLabels = [{
  label: '一级标题',
  value: 'name'
}, {
  label: '类型',
  value: 'type'
}]
function getTypes () {
  let options = []
  detectionChineseType.forEach(item => {
    let signalItem = {
      label: item.value,
      value: item.key
    }
    options.push(signalItem)
  })
  return options
}
